import { render, staticRenderFns } from "./ResourcesAddEdit.vue?vue&type=template&id=48855d2c&"
import script from "./ResourcesAddEdit.vue?vue&type=script&lang=js&"
export * from "./ResourcesAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports